// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Contract Review application registration.
 */
import { registerApplication } from '../../core/layout-registry'
import { ContractReviewUserView } from './components/UserView'
import { ContractReviewAdminView } from './components/AdminView'
import { UploadsDashboard } from './components/UploadsDashboard'
import { OciDashboard } from './components/oci-dashboard/OciDashboard'
import './renderer-components/register'

registerApplication({
  id: 'contract-review',
  name: 'Contract Review',
  description: 'Document review application with pipeline execution and results display',
  components: [
    {
      id: 'applications/contract-review',
      label: 'Contract Review',
      icon: 'Table',
      category: 'application',
      description: 'Uploaded documents (no analysis results)',
      order: 10,
      Component: UploadsDashboard,
    },
    {
      id: 'applications/contract-review.legacy',
      label: 'Contract Review (legacy)',
      icon: 'Table',
      category: 'application',
      description: 'Legacy combined dashboard with run controls and analysis results',
      order: 900,
      Component: ContractReviewUserView,
      ConfigComponent: ContractReviewAdminView,
    },
    {
      id: 'applications/contract-review-oci-dashboard',
      label: 'OCI Award Review',
      icon: 'ShieldAlert',
      category: 'agent-dashboard',
      description: 'Filter, sort, and export organizational-conflict findings by award',
      order: 20,
      Component: OciDashboard,
    },
  ],
})
